import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-expired-view',
  templateUrl: './link-expired-view.component.html',
  styleUrls: ['./link-expired-view.component.css'],
})
export class LinkExpiredViewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
